import React, { useState } from "react";
import { isIPad } from "../../../utils/isIPad";

export default function IPadInstallToast() {
  const [visible, setVisible] = useState(true);

  if (!isIPad() || !visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: "20px",
        left: "20px",
        width: "260px",
        padding: "16px",
        background: "#fff3cd",
        border: "1px solid #ffeeba",
        borderRadius: "10px",
        boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
        zIndex: 9999,
        animation: "slideIn 0.3s ease-out",
      }}
    >
      {/* Close button */}
      <button
        onClick={() => setVisible(false)}
        style={{
          position: "absolute",
          top: "6px",
          right: "10px",
          background: "transparent",
          border: "none",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        &times;
      </button>

      <h4 style={{ marginTop: 0, fontSize: "16px", fontWeight: "600" }}>
        📱 Install This App
      </h4>

      <p style={{ margin: "6px 0", fontSize: "14px" }}>
        To receive notifications on your iPad, please install this app:
      </p>

      <ol style={{ paddingLeft: "20px", fontSize: "14px", margin: 0 }}>
        <li>
          Tap the <strong>Share</strong> button in Safari
        </li>
        <li>
          Select <strong>Add to Home Screen</strong>
        </li>
        <li>Open the app from your Home Screen</li>
      </ol>

      {/* Animation keyframes */}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(-20px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}
